import { useContext } from 'react';
import { UserInfoContext } from '../context/UserInfoQueryContext.context';

/**
 * Hook to get the access token for all services
 * Returns the appropriate token based on authentication method:
 * - Auth0 token if authenticated via Auth0
 * - Key token if authenticated via URL key
 *
 * Use this hook for ALL services that need an access token
 */
export const useAccessToken = () => {
  const context = useContext(UserInfoContext);

  if (!context) {
    throw new Error('useAccessToken must be used within UserInfoProvider');
  }

  return context.getAccessToken;
};
